<!-- <ion-content> -->
<div class="content-grid">
    <div class="m-content">
        <div class="m-body2">
            <!-- <div class="scroll-height"> -->
            <mat-card class="mat-mfa-card">
                <mat-card-title>
                    <h2>Multi-Factor Authentication</h2>
                </mat-card-title>
                <mat-card-content>
                    <form [formGroup]="mfaForm" (ngSubmit)="submitMfa()">
                        <mat-form-field appearance="fill" style="width: 100%;">
                            <mat-label class="cron-select">Enter One Time Passcode</mat-label>
                            <input type="text" matInput formControlName="otp" (keydown)="checkLength2($event, inputText)" #inputText >
                        </mat-form-field>
                        <div class="btn-signin-grid">
                            <button mat-raised-button type="submit" class="btn-signin">Sign</button>
                        </div>
                    </form>
                    <br>
                    <p>
                        Check your registered mobile device for the temporary passcode
                    </p>
                    <p>
                        if you have trouble generating a temporary passcode with the registered device, contact your
                        admistrator to disable multi-factor authentication
                    </p>
                </mat-card-content>
            </mat-card>
            <!-- </div> -->
        </div>
    </div>
</div>

<!-- </ion-content> -->